import React from "react";
import { Globe, Check } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLanguage } from "@/context/LanguageContext";

export const LanguageSwitcher = () => {
    const { lang, setLang, langs } = useLanguage();
    return (
        <DropdownMenu modal={false}>
            <DropdownMenuTrigger asChild>
                <button
                    type="button"
                    aria-label="Change language"
                    data-testid="language-switcher"
                    className="inline-flex items-center gap-1.5 h-9 px-2.5 rounded-md border border-border/70 hover:bg-muted transition-colors mono-label"
                >
                    <Globe className="h-3.5 w-3.5" strokeWidth={1.5} />
                    {lang.toUpperCase()}
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-popover border-border/70 z-50" data-no-translate>
                {langs.map(([id, label]) => (
                    <DropdownMenuItem
                        key={id}
                        className="cursor-pointer flex items-center justify-between gap-4"
                        onClick={() => setLang(id)}
                        data-testid={`language-option-${id}`}
                    >
                        {label}
                        {lang === id && <Check className="h-3.5 w-3.5" strokeWidth={1.5} />}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
